import clsx from 'clsx';
import { useState } from 'react';
import { BiTime } from 'react-icons/bi';

import { formatMinutesToDuration, parseDurationToMinutes } from '@/utils/timeFormatter';

import s from './inputs.module.scss';

export const DurationInput = ({
  label,
  error,
  mandatory,
  value = 0,
  onChange,
  className,
}: {
  label: string;
  error?: string;
  mandatory?: boolean;
  value?: number;
  onChange(totalMinutes: number): void;
  className?: string;
}) => {
  const [inputValue, setInputValue] = useState(() => formatMinutesToDuration(value));
  const [prevValue, setPrevValue] = useState(value);

  if (value !== prevValue) {
    setPrevValue(value);
    setInputValue(formatMinutesToDuration(value));
  }

  const handleBlur = () => {
    const minutes = parseDurationToMinutes(inputValue);
    onChange(minutes);
    setInputValue(formatMinutesToDuration(minutes));
  };

  return (
    <label className={clsx(s.InputRoot, className)}>
      <div className={s.Label}>
        <span>{label}</span>
        {mandatory && <span>*</span>}
      </div>
      <div className={clsx(s.InputWrapper, error && s.error, s.withIcon)}>
        <input
          type="text"
          className="body-medium"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onBlur={handleBlur}
          placeholder="1:30"
        />
        <BiTime className={s.icon} size={20} color="var(--text-secondary)" />
      </div>
      {!!error && <p className={s.Error}>{error}</p>}
    </label>
  );
};
